import { render, staticRenderFns } from "./IndexBar.vue?vue&type=template&id=0b15740a&"
import script from "./IndexBar.vue?vue&type=script&lang=js&"
export * from "./IndexBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports